import styled from "styled-components";

export const StyledFeeWrapper = styled.div`
  .apply-to-wrapper {
    margin: 0;
  }
  .admin-filter {
    padding: 15px 0 25px;
    display: grid;
    grid-template-columns: max-content 175px;
    grid-gap: 20px;

    @media screen and (max-width: 576px) {
      grid-template-columns: 100%;
    }
  }
  .fee-head {
    padding: 15px 0 25px;
    display: grid;
    align-items: center;
    grid-template-columns: max-content 1fr;
    grid-gap: 25px;
    &__left {
      display: grid;
      align-items: center;
      grid-template-columns: repeat(2, max-content) 175px;
      grid-template-rows: 1fr;
      grid-gap: 20px;
      @media screen and (max-width: 576px) {
        grid-template-columns: 175px max-content;
      }
    }
    @media screen and (max-width: 992px) {
      grid-template-columns: repeat(2, max-content);
      grid-gap: 20px;
    }
    @media screen and (max-width: 768px) {
      grid-template-columns: 100%;
    }
  }
`;

export const StyledFeeDetailsWrapper = styled.div`
  .fee-edit {
    display: grid;
    grid-template-columns: 150px 1fr;
    &__items {
      display: grid;
      grid-template-columns: 100%;
      grid-gap: 25px;
    }
    @media screen and (max-width: 576px) {
      grid-template-columns: 100px 1fr;
    }
  }
`;